import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      // Navigation
      "sites": "Sites",
      "logout": "Déconnexion",

      // Login
      "login": "Connexion",
      "email": "Email",
      "password": "Mot de passe",
      "signIn": "Se connecter",
      "forgotPassword": "Mot de passe oublié ?",
      "forgotPasswordDescription": "Entrez votre adresse email. Un nouveau mot de passe sera généré et vous sera envoyé par email.",
      "sendNewPassword": "Envoyer un nouveau mot de passe",
      "forgotPasswordSuccess": "Si un compte existe avec cet email, un nouveau mot de passe a été envoyé.",
      "forgotPasswordError": "Erreur lors de la réinitialisation du mot de passe. Veuillez réessayer.",
      "close": "Fermer",

      // Errors
      "errorTitle": "Erreur",
      "saveError": "Erreur lors de la sauvegarde",
      "validationError": "Erreur de validation",
      "fields": {
        "nom_site": "Nom du site",
        "adresse": "Adresse",
        "ville": "Ville",
        "pays": "Pays",
        "province": "Province",
        "congregation": "Congrégation",
        "type_batiment": "Type de bâtiment",
        "annee_acquisition": "Année d'acquisition",
        "surface_jardins": "Surface des jardins",
        "nombre_batiments": "Nombre de bâtiments",
        "nombre_personnes_residentes": "Nombre de résidents",
        "nombre_employes": "Nombre d'employés",
        "nombre_personnes_accueillis": "Nombre de personnes accueillies"
      },

      // Sites List
      "sitesList": "Liste des sites",
      "addSite": "Ajouter un site",
      "siteName": "Nom du site",
      "city": "Ville",
      "country": "Pays",
      "operatingBudget": "Budget d'exploitation",
      "expensesAmount": "Montant Dépenses",
      "revenuesAmount": "Montant Revenus",
      "sortBy": "Trier par",
      "sortDefault": "Ordre par défaut",
      "toggleSortDirection": "Inverser l'ordre de tri",
      "investmentBudget": "Budget d'investissement",
      "actions": "Actions",
      "edit": "Modifier",
      "delete": "Supprimer",
      "generatePdf": "Générer PDF",
      "exportPdf": "Exporter la liste en PDF",
      "exportData": "Export données",
      "exportSiteListPdf": "Export de la liste des sites en PDF",
      "exportAssessmentsPdf": "Export des derniers diagnostics en PDF",
      "noAssessmentsToExport": "Aucun diagnostic terminé pour les sites affichés.",
      "exportAssessmentsError": "Erreur lors de l'export des diagnostics.",
      "exportExcel": "Exporter la liste en Excel",
      "searchFilter": "Filtre",
      "totalSites": "Sites totaux",
      "filteredSites": "Sites filtrés",
      "outOf": "sur",
      "totalSitesCount": "sites au total",
      "filteredSelection": "Sélection filtrée",

      // Site Form
      "siteIdentity": "Fiche d'identité",
      "riskAnalysis": "Liste des investissements",
      "operatingBudgetTab": "Budget d'exploitation",
      "investmentBudgetTab": "Budget d'investissement",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "previous": "Précédent",
      "next": "Suivant",

      // Site Identity Fields
      "address": "Adresse",
      "buildingType": "Type de bâtiment",
      "destination": "Usage du site",
      "siteUsage": "Usage du site",
      "legalStatus": "Statut juridique",
      "owner": "Propriétaire",
      "tenant": "Locataire",
      "rented": "Loué",
      "occupationStatus": "Statut Occupation",
      "easement": "Servitude",
      "yes": "Oui",
      "no": "Non",
      "unknown": "Inconnu",
      "acquisitionYear": "Année d'acquisition ou de construction",
      "rentalYear": "Année de location",
      "rentedSince": "Site loué depuis",
      "rentedUntil": "Site loué jusqu'à",
      "building": "Bâtiment",
      "buildingUsage": "Usage du bâtiment",
      "buildingSurface": "Surface du bâtiment (m²)",
      "gardenSurface": "Surface des jardins (m²)",
      "floors": "Nombre de niveaux",
      "buildings": "Nombre de bâtiments",
      "people": "Nombre de personnes",
      "residentsCount": "Nombre de sœurs résidentes",
      "employeesCount": "Nombre d'employés",
      "guestsCount": "Capacité d'accueil",
      "currency": "Devise du pays",
      "province": "Province/Région",
      "congregation": "Congrégation",
      "image": "Photo du site",
      "sitePhotoDescription": "Photo principale d'identification du site",
      "uploadImage": "Télécharger une photo",
      "changeImage": "Changer la photo",
      "siteDocuments": "Documents du site",
      "siteDocumentsDescription": "Ajoutez ici les documents relatifs au site : actes de propriété, contrats de location, plans, etc.",
      "addDocument": "Ajouter un document",
      "addDocumentHint": "PDF, JPEG, PNG (max 10 MB)",
      "noDocuments": "Aucun document ajouté",
      "saveSiteFirst": "Veuillez d'abord enregistrer le site pour ajouter des documents",
      "documentUploaded": "Document ajouté avec succès",
      "documentDeleted": "Document supprimé avec succès",
      "documentUploadError": "Erreur lors de l'ajout du document",
      "documentDeleteError": "Erreur lors de la suppression du document",
      "confirmDeleteDocument": "Êtes-vous sûr de vouloir supprimer ce document ?",

      // Provinces
      "provinces": {
        "bresil": "Brésil",
        "region_asie": "Région Asie",
        "madagascar": "Madagascar",
        "europe_togo": "Europe-Togo",
        "amerique_nord": "Amérique du Nord",
        "nouvelle_zelande": "Nouvelle Zélande",
        "generalat": "Généralat"
      },

      // Building Types
      "buildingTypes": {
        "maison_accueil": "Maison d'accueil/de Retraites Spi",
        "maison_retraite": "Maison sœurs aînées",
        "maison_cimetiere": "Caveau Funéraire",
        "chapelle": "Maison sans accueil (formation/cté/Provincialat…)",
        "eglise": "Eglise - Chapelle",
        "dependance": "Dépendance",
        "autre": "Autre"
      },

      // Occupation Statuses
      "occupationStatuses": {
        "occupant": "Occupant",
        "occupantPartiel": "Occupant partiel",
        "miseEnLocation": "Mise en location"
      },

      // Currencies
      "currencies": {
        "EUR": "Euro (€)",
        "BRL": "Réal brésilien (R$)",
        "MGA": "Ariary malgache (Ar)",
        "PHP": "Peso philippin (₱)",
        "NZD": "Dollar néo-zélandais (NZ$)",
        "USD": "Dollar américain ($)",
        "MOP": "Pataca de Macao (MOP$)",
        "SGD": "Dollar de Singapour (S$)",
        "XOF": "Franc CFA (TOGO) (CFA)",
        "GBP": "Livre sterling (£)",
        "AUD": "Dollar australien (A$)"
      },

      // Administration
      "administration": "Administration",
      "users": "Utilisateurs",
      "permissions": "Permissions",
      "userManagement": "Gestion des utilisateurs",
      "permissionManagement": "Gestion des permissions",
      "addUser": "Ajouter un utilisateur",
      "editUser": "Modifier l'utilisateur",
      "firstName": "Prénom",
      "lastName": "Nom",
      "language": "Langue",
      "admin": "Admin",
      "isAdmin": "Est administrateur",
      "addPermission": "Ajouter une permission",
      "editPermission": "Modifier la permission",
      "user": "Utilisateur",
      "site": "Site",
      "canView": "Peut voir",
      "canEdit": "Peut modifier",
      "canDelete": "Peut supprimer",
      "required": "Requis",
      "leaveEmptyToKeepCurrent": "Laisser vide pour conserver le mot de passe actuel",
      "confirmDeleteUser": "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
      "confirmDeletePermission": "Êtes-vous sûr de vouloir supprimer cette permission ?",
      "userCreatedSuccess": "Utilisateur créé avec succès",
      "userUpdatedSuccess": "Utilisateur mis à jour avec succès",
      "userDeletedSuccess": "Utilisateur supprimé avec succès",
      "permissionSavedSuccess": "Permission enregistrée avec succès",
      "permissionDeletedSuccess": "Permission supprimée avec succès",
      "errorFetchingUsers": "Erreur lors du chargement des utilisateurs",
      "errorFetchingSites": "Erreur lors du chargement des sites",
      "errorFetchingPermissions": "Erreur lors du chargement des permissions",
      "errorSavingUser": "Erreur lors de l'enregistrement de l'utilisateur",
      "errorDeletingUser": "Erreur lors de la suppression de l'utilisateur",
      "errorSavingPermission": "Erreur lors de l'enregistrement de la permission",
      "errorDeletingPermission": "Erreur lors de la suppression de la permission",
      "passwordRequired": "Le mot de passe est requis",
      "accessDeniedAdmin": "Accès refusé : droits d'administrateur requis",
      "errorCheckingAdmin": "Erreur lors de la vérification des droits d'administrateur",
      "role": "Rôle",
      "userProvince": "Province de l'utilisateur",
      "roles": {
        "super_admin": "Super Administrateur",
        "admin_province": "Administrateur Province",
        "user": "Utilisateur"
      },
      "rolesDescription": {
        "title": "Droits par rôle",
        "permission": "Permission",
        "super_admin_desc": "Accès complet à tous les sites et à toutes les fonctionnalités. Peut gérer les utilisateurs, les permissions et valider les investissements de toutes les provinces.",
        "admin_province_desc": "Accès aux sites de sa province uniquement. Peut créer des utilisateurs et gérer les permissions dans sa province. Peut valider les investissements de sa province.",
        "user_desc": "Accès uniquement aux sites qu'il a créés ou pour lesquels des permissions explicites lui ont été attribuées.",
        "manage_users": "Gérer les utilisateurs",
        "manage_permissions": "Gérer les permissions",
        "validate_investments": "Valider les investissements",
        "access_all_sites": "Accès à tous les sites",
        "access_province_sites": "Accès aux sites de sa province",
        "create_sites": "Créer des sites",
        "all_provinces": "Toutes les provinces",
        "own_province_only": "Sa province uniquement",
        "assigned_sites_only": "Sites attribués uniquement"
      },
      "validationStatus": {
        "en_attente": "En attente",
        "valide": "Validé",
        "rejete": "Rejeté"
      },
      "validate": "Valider",
      "reject": "Rejeter",
      "validationComment": "Commentaire de validation",
      "pendingValidations": "Validations en attente",
      "validatedBy": "Validé par",
      "validatedAt": "Validé le",
      "validationTab": "Validations",
      "status": "Statut",
      "investmentValidated": "Investissement validé avec succès",
      "investmentRejected": "Investissement rejeté",
      "noValidationPermission": "Vous n'avez pas les droits de validation",

      // Risk Analysis
      "addRisk": "Ajouter un investissement",
      "investmentLabel": "Investissement",
      "removeValidation": "Annuler la validation",
      "theme": "Thématique",
      "item": "Item",
      "description": "Description",
      "riskExists": "Existe-t-il un risque ?",
      "why": "Pourquoi ?",
      "attachedFile": "Pièce jointe",
      "uploadFile": "Joindre un fichier",
      "viewFile": "Visualiser",
      "downloadFile": "Télécharger",
      "deleteFile": "Supprimer",
      "saveInvestmentFirst": "Enregistrez d'abord l'investissement pour joindre un fichier",
      "fileUploadError": "Erreur lors de l'upload du fichier",
      "fileViewError": "Erreur lors de la visualisation du fichier",
      "fileDownloadError": "Erreur lors du téléchargement du fichier",
      "fileDeleteError": "Erreur lors de la suppression du fichier",
      "confirmDeleteFile": "Êtes-vous sûr de vouloir supprimer ce fichier ?",
      "urgency": "URGENCE (Y a-t-il un risque immédiat ?)",
      "security": "SÉCURITÉ (La sécurité des personnes est elle menacée ?)",
      "regulatory": "LEGAL / RÉGLEMENTAIRE (Y a-t-il un risque légal ou réglementaire ?)",
      "financial": "FINANCIER (Y aura-t-il aggravation du coût en cas de non-action rapide ?)",
      "geoWeighting": "Pondération géographique (%)",
      "severityLevel": "Niveau de gravité",
      "critical": "Critique",
      "important": "Important",
      "moderate": "Modéré",
      "low": "Faible",
      "observations": "Observations",
      "other": "Autre",

      // Operating Budget
      "category": "Catégorie",
      "budgetItem": "Item",
      "frequency": "Fréquence",
      "nature": "Nature",
      "amount": "Montant",
      "annualAmount": "Montant annuel",

      // Investment Budget
      "score": "Score",
      "investmentAmount": "Montant d'investissement",
      "adjustment": "Ajustement (%)",
      "adjustedAmount": "Montant pondéré",
      "quotationOrigin": "Origine du chiffrage",
      "yearN": "Année N",
      "yearN1": "Année N+1",
      "yearN2": "Année N+2",
      "yearN3": "Année N+3",
      "yearN4": "Année N+4",
      "yearN5": "Année N+5",
      "congregationForm": "Formulaire de la congrégation",
      "budgetAllocationControl": "Contrôle affection budget",
      "scope": "Périmètre",
      "building": "Bâtiment",
      "entireSite": "Ensemble du site",
      "referenceYear": "Année de référence",
      "forecastAmount": "Montant prévisionnel",
      "realizedAmount": "Montant réalisé",
      "forecast": "Prévisionnel",
      "realized": "Réalisé",
      "annualDetail": "Détail annuel",
      "annualBreakdown": "Répartition annuelle",
      "totalForecast": "Total prévisionnel",
      "totalRealized": "Total réalisé",
      "year": "Année",
      "expand": "Détailler par bâtiment",
      "collapse": "Replier",
      "siteTotal": "Total site",
      "perBuilding": "Par bâtiment",
      "expandHint": "Cliquez pour saisir un budget par bâtiment",
      "collapseHint": "Repli : retour au budget site global",
      "expandConfirmTitle": "Passer en budget par bâtiment ?",
      "expandConfirmMessage": "Le montant global de cette ligne sera réinitialisé et remplacé par une saisie par bâtiment. Confirmer ?",
      "collapseConfirmTitle": "Revenir au budget global ?",
      "collapseConfirmMessage": "Les montants saisis par bâtiment seront additionnés sur une seule ligne site et les commentaires regroupés. Confirmer ?",
      "confirm": "Confirmer",
      "cancel": "Annuler",
      "riskScores": "Scores risques",
      "riskCount": "Nb d'investissements",
      "totalExpenses": "Total Dépenses",
      "totalRevenues": "Total Revenus",
      "operatingBudgetTotal": "Budget d'exploitation",
      "exportOperatingBudget": "Export budget d'exploitation (Excel)",
      "exportInvestmentBudget": "Export budget d'investissement (Excel)",
      "exportSiteList": "Export liste des sites",
      "exportConsolidatedOperating": "Budget exploitation consolidé par province",
      "exportConsolidatedInvestment": "Budget investissement consolidé par province",
      "exportDetailedOperating": "Budget exploitation détaillé par site",
      "subtotal": "Sous-total",
      "comment": "Commentaire",
      "addComment": "Ajouter un commentaire",
      "editComment": "Modifier le commentaire",
      "saveComment": "Enregistrer",
      "cancelComment": "Annuler",
      "noComment": "Aucun commentaire",
      "search": "Rechercher",
      "searchSites": "Rechercher des sites...",
      "plans": "Plans",
      "siteMap": "Carte des sites",
      "noCoordinates": "Pas de coordonnées GPS",
      "high": "Élevé",
      "veryHigh": "Très élevé",
      "userGuide": "Guide utilisateur",

      // Thematiques (Risk Analysis)
      "thematiques": {
        "statut_juridique": "Statut juridique du bien",
        "assurance": "Assurance du patrimoine",
        "conformite": "Conformité réglementaire",
        "gros_oeuvre": "État du gros œuvre",
        "reseaux": "Réseaux techniques",
        "patrimoine_protege": "Patrimoine protégé / classé",
        "environnement": "Contraintes environnementales / climatiques",
        "incidents": "Incidents récents / dégradations",
        "audits": "Audits et contrôles",
        "pmr": "Accessibilité PMR",
        "incendie": "Sécurité incendie",
        "autre": "Autre"
      },

      // Risk Items
      "riskItems": {
        "titre_propriete": "Titre de propriété / acte notarié",
        "contentieux_cours": "Contentieux en cours",
        "precedent_litige": "Précédent de litige",
        "revendication_recente": "Revendication recente",
        "assurance_multirisques": "Assurance multirisques",
        "garantie_decennale": "Garantie décennale",
        "attestation_recente": "Attestation récente",
        "contrat_renouveler": "Contrat à renouveler",
        "securite_incendie": "Sécurité incendie",
        "accessibilite_pmr": "Accessibilité PMR",
        "normes_electriques": "Normes électriques",
        "normes_hvac": "Normes HVAC",
        "murs_facades": "Murs extérieurs / façades",
        "charpente_toiture": "Charpente / toiture",
        "fondation_sol": "Fondation / sol",
        "escaliers_principal": "Escaliers / escalier principal",
        "electricite_reseau": "Electricité",
        "plomberie": "Plomberie",
        "chauffage_ventilation": "Chauffage / ventilation",
        "systemes_securite_incendie": "Systèmes de sécurité incendie",
        "chapelle_classee": "Chapelle classée ou monument historique",
        "facades_protegees": "Façades protégées",
        "interieur_classe": "Intérieur classé",
        "zones_reglementees": "Zones réglementées",
        "humidite_moisissures": "Humidité / moisissures",
        "pollution_urbaine": "Pollution urbaine",
        "risques_gel_chaleur": "Risques de gel / chaleur",
        "actions_energetiques": "Actions énergétiques",
        "infiltration": "Infiltration",
        "fissures_surface": "Fissures surface",
        "peintures_ecaillees": "Peintures écaillées",
        "degradation_structurelle": "Dégradation structurelle",
        "audit_structure": "Audit structure",
        "audit_electrique": "Audit électrique",
        "audit_environnemental": "Audit environnemental",
        "controles_reglementaires": "Contrôles réglementaires",
        "escaliers_etroits": "Escaliers étroits",
        "rampes_inexistantes": "Rampes inexistantes / inadéquates",
        "ascenseur_prevoir": "Ascenseur à prévoir",
        "signaletique_adaptee": "Signalétique adaptée",
        "detecteurs_incendie": "Détecteurs incendie",
        "extincteurs": "Extincteurs",
        "systemes_alarme": "Systèmes d'alarme",
        "compartimentage": "Compartimentage",
        "autre": "Autre"
      },

      // Operating Budget Categories
      "budgetCategories": {
        "assurances": "Assurances",
        "entretien_maintenance": "Entretien & Maintenance",
        "energie": "Énergie",
        "nettoyage_hygiene": "Nettoyage & Hygiène",
        "personnel_gestion": "Personnel & Gestion",
        "revenus": "Revenus"
      },

      // Operating Budget Items
      "budgetItems": {
        "assurance_multirisques": "Assurance multirisques bâtiment",
        "assurance_responsabilite": "Assurance responsabilité civile",
        "assurance_renouvellement": "Assurance (renouvellement contrat annuel)",
        "entretien_toiture": "Entretien toiture et gouttières",
        "entretien_cloches": "Entretien cloches et campanile",
        "entretien_facade": "Entretien façade et menuiseries",
        "entretien_chauffage": "Entretien chauffage et chaudière",
        "entretien_ventilation": "Entretien ventilation/climatisation",
        "entretien_ascenseur": "Entretien ascenseur (si présent)",
        "entretien_electricite": "Entretien électricité (contrôle, vérification)",
        "entretien_plomberie": "Entretien plomberie et sanitaires",
        "entretien_alarme": "Equipements d'alarme et de sécurité",
        "securite": "Réseaux de sécurité",
        "entretien_batiment": "Entretien du bâtiment (peinture, porte, fenêtre…)",
        "jardin": "Jardin",
        "panneaux_solaires": "Panneaux solaires",
        "reseau_informatique": "Réseau informatique",
        "chauffage_annuel": "Gaz",
        "electricite": "Électricité",
        "eau": "Eau",
        "electricite_eau_sanitaire": "Fioul",
        "nettoyage_regulier": "Contrat Interne",
        "nettoyage_specialise": "Contrat Externe",
        "salaire_gardien": "Salaire Personnel affecté à 100% à l'immeuble",
        "salaire_maintenance": "Quote-part Salaire de Personnel répartie entre immeubles",
        "honoraires_syndic": "Honoraires syndic/gestion administrative",
        "revenu_location": "Revenu de location",
        "vente_energie_renouvelable": "Vente énergie renouvelable",
        "dons_legs": "Dons et legs",
        "divers": "Divers"
      },

      // Operating Budget Frequencies
      "budgetFrequencies": {
        "annuel": "Annuel",
        "selon_besoin": "Selon besoin",
        "mensuel": "Mensuel",
        "hebdomadaire_mensuel": "Hebdomadaire/mensuel",
        "trimestriel": "Trimestriel"
      },

      // Operating Budget Natures
      "budgetNatures": {
        "recurrente": "Récurrente",
        "maintenance": "Maintenance",
        "energie": "Énergie",
        "nettoyage": "Nettoyage",
        "personnel": "Personnel",
        "gestion": "Gestion"
      },

      // Profile
      "myProfile": "Mon profil",
      "personalInfo": "Informations personnelles",
      "changePassword": "Changer le mot de passe",
      "changePasswordHint": "Laissez ces champs vides si vous ne souhaitez pas changer de mot de passe.",
      "currentPassword": "Mot de passe actuel",
      "newPassword": "Nouveau mot de passe",
      "confirmPassword": "Confirmer le mot de passe",
      "passwordMinLength": "Minimum 12 caractères",
      "passwordMismatch": "Les mots de passe ne correspondent pas",
      "passwordRequirements": "Exigences du mot de passe :",
      "passwordReqMinLength": "Au moins 12 caractères",
      "passwordReqLowercase": "Au moins une lettre minuscule",
      "passwordReqUppercase": "Au moins une lettre majuscule",
      "passwordReqDigit": "Au moins un chiffre",
      "passwordReqSpecial": "Au moins un caractère spécial (@$!%*?&#)",
      "currentPasswordRequired": "Le mot de passe actuel est requis pour changer de mot de passe",
      "profileUpdateSuccess": "Profil mis à jour avec succès",
      "profileUpdateError": "Erreur lors de la mise à jour du profil",
      "profileLoadError": "Erreur lors du chargement du profil",
      "saving": "Enregistrement..."
    }
  },
  en: {
    translation: {
      "sites": "Sites",
      "logout": "Logout",
      "login": "Login",
      "email": "Email",
      "password": "Password",
      "signIn": "Sign In",
      "forgotPassword": "Forgot password?",
      "forgotPasswordDescription": "Enter your email address. A new password will be generated and sent to you by email.",
      "sendNewPassword": "Send new password",
      "forgotPasswordSuccess": "If an account exists with this email, a new password has been sent.",
      "forgotPasswordError": "Error resetting password. Please try again.",
      "close": "Close",

      // Errors
      "errorTitle": "Error",
      "saveError": "Error while saving",
      "validationError": "Validation error",
      "fields": {
        "nom_site": "Site name",
        "adresse": "Address",
        "ville": "City",
        "pays": "Country",
        "province": "Province",
        "congregation": "Congregation",
        "type_batiment": "Building type",
        "annee_acquisition": "Year of acquisition",
        "surface_jardins": "Garden area",
        "nombre_batiments": "Number of buildings",
        "nombre_personnes_residentes": "Number of residents",
        "nombre_employes": "Number of employees",
        "nombre_personnes_accueillis": "Number of guests"
      },

      "sitesList": "Sites List",
      "addSite": "Add Site",
      "siteName": "Site Name",
      "city": "City",
      "country": "Country",
      "operatingBudget": "Operating Budget",
      "expensesAmount": "Expenses Amount",
      "revenuesAmount": "Revenues Amount",
      "sortBy": "Sort by",
      "sortDefault": "Default order",
      "toggleSortDirection": "Reverse sort order",
      "investmentBudget": "Investment Budget",
      "actions": "Actions",
      "edit": "Edit",
      "delete": "Delete",
      "generatePdf": "Generate PDF",
      "exportPdf": "Export list to PDF",
      "exportData": "Export data",
      "exportSiteListPdf": "Export site list as PDF",
      "exportAssessmentsPdf": "Export latest check-ups as PDF",
      "noAssessmentsToExport": "No completed check-up for the displayed sites.",
      "exportAssessmentsError": "Error while exporting the check-ups.",
      "exportExcel": "Export list to Excel",
      "searchFilter": "Filter",
      "totalSites": "Total Sites",
      "filteredSites": "Filtered Sites",
      "outOf": "out of",
      "totalSitesCount": "total sites",
      "filteredSelection": "Filtered selection",
      "siteIdentity": "Site Identity",
      "riskAnalysis": "Investment List",
      "operatingBudgetTab": "Operating Budget",
      "investmentBudgetTab": "Investment Budget",
      "save": "Save",
      "cancel": "Cancel",
      "previous": "Previous",
      "next": "Next",
      "address": "Address",
      "buildingType": "Building Type",
      "destination": "Site Usage",
      "siteUsage": "Site Usage",
      "legalStatus": "Legal Status",
      "owner": "Owner",
      "tenant": "Tenant",
      "rented": "Rented",
      "occupationStatus": "Occupation Status",
      "easement": "Easement",
      "yes": "Yes",
      "no": "No",
      "unknown": "Unknown",
      "acquisitionYear": "Year of Acquisition or Construction",
      "rentalYear": "Rental Year",
      "rentedSince": "Rented since",
      "rentedUntil": "Rented until",
      "building": "Building",
      "buildingUsage": "Building Usage",
      "buildingSurface": "Building Surface (m²)",
      "gardenSurface": "Garden Surface (m²)",
      "floors": "Number of Levels",
      "buildings": "Number of Buildings",
      "people": "Number of People",
      "residentsCount": "Number of Resident Sisters",
      "employeesCount": "Number of Employees",
      "guestsCount": "Accommodation Capacity",
      "currency": "Country Currency",
      "province": "Province/Region",
      "congregation": "Congregation",
      "image": "Site Photo",
      "sitePhotoDescription": "Main identification photo of the site",
      "uploadImage": "Upload Photo",
      "changeImage": "Change Photo",
      "siteDocuments": "Site Documents",
      "siteDocumentsDescription": "Add documents related to the site here: property deeds, rental agreements, plans, etc.",
      "addDocument": "Add a document",
      "addDocumentHint": "PDF, JPEG, PNG (max 10 MB)",
      "noDocuments": "No documents added",
      "saveSiteFirst": "Please save the site first to add documents",
      "documentUploaded": "Document uploaded successfully",
      "documentDeleted": "Document deleted successfully",
      "documentUploadError": "Error uploading document",
      "documentDeleteError": "Error deleting document",
      "confirmDeleteDocument": "Are you sure you want to delete this document?",

      // Provinces
      "provinces": {
        "bresil": "Brazil",
        "region_asie": "Asia Region",
        "madagascar": "Madagascar",
        "europe_togo": "Europe-Togo",
        "amerique_nord": "North America",
        "nouvelle_zelande": "New Zealand",
        "generalat": "Generalate"
      },

      // Building Types
      "buildingTypes": {
        "maison_accueil": "Welcome House/Spiritual Retreats",
        "maison_retraite": "Senior Sisters House",
        "maison_cimetiere": "Funeral Vault",
        "chapelle": "House without reception (training/community/Provincialate…)",
        "eglise": "Church - Chapel",
        "dependance": "Outbuilding",
        "autre": "Other"
      },

      // Occupation Statuses
      "occupationStatuses": {
        "occupant": "Occupant",
        "occupantPartiel": "Partial Occupant",
        "miseEnLocation": "For Rent"
      },

      // Currencies
      "currencies": {
        "EUR": "Euro (€)",
        "BRL": "Brazilian Real (R$)",
        "MGA": "Malagasy Ariary (Ar)",
        "PHP": "Philippine Peso (₱)",
        "NZD": "New Zealand Dollar (NZ$)",
        "USD": "US Dollar ($)",
        "MOP": "Macanese Pataca (MOP$)",
        "SGD": "Singapore Dollar (S$)",
        "XOF": "CFA Franc (TOGO) (CFA)",
        "GBP": "Pound Sterling (£)",
        "AUD": "Australian Dollar (A$)"
      },

      // Administration
      "administration": "Administration",
      "users": "Users",
      "permissions": "Permissions",
      "userManagement": "User Management",
      "permissionManagement": "Permission Management",
      "addUser": "Add User",
      "editUser": "Edit User",
      "firstName": "First Name",
      "lastName": "Last Name",
      "language": "Language",
      "admin": "Admin",
      "isAdmin": "Is Administrator",
      "addPermission": "Add Permission",
      "editPermission": "Edit Permission",
      "user": "User",
      "site": "Site",
      "canView": "Can View",
      "canEdit": "Can Edit",
      "canDelete": "Can Delete",
      "required": "Required",
      "leaveEmptyToKeepCurrent": "Leave empty to keep current password",
      "confirmDeleteUser": "Are you sure you want to delete this user?",
      "confirmDeletePermission": "Are you sure you want to delete this permission?",
      "userCreatedSuccess": "User created successfully",
      "userUpdatedSuccess": "User updated successfully",
      "userDeletedSuccess": "User deleted successfully",
      "permissionSavedSuccess": "Permission saved successfully",
      "permissionDeletedSuccess": "Permission deleted successfully",
      "errorFetchingUsers": "Error loading users",
      "errorFetchingSites": "Error loading sites",
      "errorFetchingPermissions": "Error loading permissions",
      "errorSavingUser": "Error saving user",
      "errorDeletingUser": "Error deleting user",
      "errorSavingPermission": "Error saving permission",
      "errorDeletingPermission": "Error deleting permission",
      "passwordRequired": "Password is required",
      "accessDeniedAdmin": "Access denied: Administrator rights required",
      "errorCheckingAdmin": "Error checking administrator rights",
      "role": "Role",
      "userProvince": "User Province",
      "roles": {
        "super_admin": "Super Administrator",
        "admin_province": "Province Administrator",
        "user": "User"
      },
      "rolesDescription": {
        "title": "Rights by role",
        "permission": "Permission",
        "super_admin_desc": "Full access to all sites and features. Can manage users, permissions and validate investments for all provinces.",
        "admin_province_desc": "Access to sites in their province only. Can create users and manage permissions within their province. Can validate investments for their province.",
        "user_desc": "Access only to sites they created or for which explicit permissions have been granted.",
        "manage_users": "Manage users",
        "manage_permissions": "Manage permissions",
        "validate_investments": "Validate investments",
        "access_all_sites": "Access all sites",
        "access_province_sites": "Access province sites",
        "create_sites": "Create sites",
        "all_provinces": "All provinces",
        "own_province_only": "Own province only",
        "assigned_sites_only": "Assigned sites only"
      },
      "validationStatus": {
        "en_attente": "Pending",
        "valide": "Validated",
        "rejete": "Rejected"
      },
      "validate": "Validate",
      "reject": "Reject",
      "validationComment": "Validation comment",
      "pendingValidations": "Pending validations",
      "validatedBy": "Validated by",
      "validatedAt": "Validated on",
      "validationTab": "Validations",
      "status": "Status",
      "investmentValidated": "Investment validated successfully",
      "investmentRejected": "Investment rejected",
      "noValidationPermission": "You do not have validation rights",

      "addRisk": "Add Investment",
      "investmentLabel": "Investment",
      "removeValidation": "Remove validation",
      "theme": "Theme",
      "item": "Item",
      "description": "Description",
      "riskExists": "Does a risk exist?",
      "why": "Why?",
      "attachedFile": "Attachment",
      "uploadFile": "Attach a file",
      "viewFile": "View",
      "downloadFile": "Download",
      "deleteFile": "Delete",
      "saveInvestmentFirst": "Save the investment first to attach a file",
      "fileUploadError": "Error uploading file",
      "fileViewError": "Error viewing file",
      "fileDownloadError": "Error downloading file",
      "fileDeleteError": "Error deleting file",
      "confirmDeleteFile": "Are you sure you want to delete this file?",
      "urgency": "URGENCY (Is there an immediate risk?)",
      "security": "SECURITY (Is people's safety threatened?)",
      "regulatory": "LEGAL / REGULATORY (Is there a legal or regulatory risk?)",
      "financial": "FINANCIAL (Will there be cost aggravation if no quick action?)",
      "geoWeighting": "Geographic Weighting (%)",
      "severityLevel": "Severity Level",
      "critical": "Critical",
      "important": "Important",
      "moderate": "Moderate",
      "low": "Low",
      "observations": "Observations",
      "other": "Other",
      "category": "Category",
      "budgetItem": "Item",
      "frequency": "Frequency",
      "nature": "Nature",
      "amount": "Amount",
      "annualAmount": "Annual Amount",
      "score": "Score",
      "investmentAmount": "Investment Amount",
      "adjustment": "Adjustment (%)",
      "adjustedAmount": "Adjusted Amount",
      "quotationOrigin": "Quotation Origin",
      "yearN": "Year N",
      "yearN1": "Year N+1",
      "yearN2": "Year N+2",
      "yearN3": "Year N+3",
      "yearN4": "Year N+4",
      "yearN5": "Year N+5",
      "scope": "Scope",
      "building": "Building",
      "entireSite": "Entire site",
      "referenceYear": "Reference year",
      "forecastAmount": "Forecast amount",
      "realizedAmount": "Realized amount",
      "forecast": "Forecast",
      "realized": "Realized",
      "annualDetail": "Annual detail",
      "annualBreakdown": "Annual breakdown",
      "totalForecast": "Total forecast",
      "totalRealized": "Total realized",
      "year": "Year",
      "expand": "Detail per building",
      "collapse": "Collapse",
      "siteTotal": "Site total",
      "perBuilding": "Per building",
      "expandHint": "Click to enter a budget per building",
      "collapseHint": "Collapse: back to global site budget",
      "expandConfirmTitle": "Switch to per-building budget?",
      "expandConfirmMessage": "The global amount for this line will be reset and replaced by a per-building entry. Confirm?",
      "collapseConfirmTitle": "Back to global budget?",
      "collapseConfirmMessage": "The amounts entered per building will be summed into a single site line and comments merged. Confirm?",
      "confirm": "Confirm",
      "cancel": "Cancel",
      "congregationForm": "Congregation Form",
      "budgetAllocationControl": "Budget Allocation Control",
      "riskScores": "Risk Scores",
      "riskCount": "Investment Count",
      "totalExpenses": "Total Expenses",
      "totalRevenues": "Total Revenues",
      "operatingBudgetTotal": "Operating Budget",
      "exportOperatingBudget": "Export operating budget (Excel)",
      "exportInvestmentBudget": "Export investment budget (Excel)",
      "exportSiteList": "Export site list",
      "exportConsolidatedOperating": "Consolidated operating budget by province",
      "exportConsolidatedInvestment": "Consolidated investment budget by province",
      "exportDetailedOperating": "Detailed operating budget by site",
      "subtotal": "Subtotal",
      "comment": "Comment",
      "addComment": "Add a comment",
      "editComment": "Edit comment",
      "saveComment": "Save",
      "cancelComment": "Cancel",
      "noComment": "No comment",
      "search": "Search",
      "searchSites": "Search sites...",
      "plans": "Plans",
      "siteMap": "Site Map",
      "noCoordinates": "No GPS coordinates",
      "high": "High",
      "veryHigh": "Very High",
      "userGuide": "User Guide",

      // Thematiques (Risk Analysis)
      "thematiques": {
        "statut_juridique": "Legal status of the property",
        "assurance": "Property insurance",
        "conformite": "Regulatory compliance",
        "gros_oeuvre": "Structural condition",
        "reseaux": "Technical networks",
        "patrimoine_protege": "Protected / listed heritage",
        "environnement": "Environmental / climate constraints",
        "incidents": "Recent incidents / degradations",
        "audits": "Audits and inspections",
        "pmr": "Disabled accessibility (PMR)",
        "incendie": "Fire safety",
        "autre": "Other"
      },

      // Risk Items
      "riskItems": {
        "titre_propriete": "Title deed / notarial act",
        "contentieux_cours": "Ongoing litigation",
        "precedent_litige": "Previous dispute",
        "revendication_recente": "Recent claim",
        "assurance_multirisques": "Multi-risk insurance",
        "garantie_decennale": "Ten-year warranty",
        "attestation_recente": "Recent certificate",
        "contrat_renouveler": "Contract to be renewed",
        "securite_incendie": "Fire safety",
        "accessibilite_pmr": "Disabled accessibility (PMR)",
        "normes_electriques": "Electrical standards",
        "normes_hvac": "HVAC standards",
        "murs_facades": "Exterior walls / facades",
        "charpente_toiture": "Framework / roofing",
        "fondation_sol": "Foundation / ground",
        "escaliers_principal": "Stairs / main staircase",
        "electricite_reseau": "Electricity",
        "plomberie": "Plumbing",
        "chauffage_ventilation": "Heating / ventilation",
        "systemes_securite_incendie": "Fire safety systems",
        "chapelle_classee": "Listed chapel or historical monument",
        "facades_protegees": "Protected facades",
        "interieur_classe": "Listed interior",
        "zones_reglementees": "Regulated areas",
        "humidite_moisissures": "Humidity / mold",
        "pollution_urbaine": "Urban pollution",
        "risques_gel_chaleur": "Frost / heat risks",
        "actions_energetiques": "Energy actions",
        "infiltration": "Infiltration",
        "fissures_surface": "Surface cracks",
        "peintures_ecaillees": "Peeling paint",
        "degradation_structurelle": "Structural degradation",
        "audit_structure": "Structural audit",
        "audit_electrique": "Electrical audit",
        "audit_environnemental": "Environmental audit",
        "controles_reglementaires": "Regulatory inspections",
        "escaliers_etroits": "Narrow stairs",
        "rampes_inexistantes": "Missing / inadequate ramps",
        "ascenseur_prevoir": "Elevator to be planned",
        "signaletique_adaptee": "Adapted signage",
        "detecteurs_incendie": "Fire detectors",
        "extincteurs": "Fire extinguishers",
        "systemes_alarme": "Alarm systems",
        "compartimentage": "Compartmentalization",
        "autre": "Other"
      },

      // Operating Budget Categories
      "budgetCategories": {
        "assurances": "Insurance",
        "entretien_maintenance": "Maintenance & Upkeep",
        "energie": "Energy",
        "nettoyage_hygiene": "Cleaning & Hygiene",
        "personnel_gestion": "Staff & Management",
        "revenus": "Revenue"
      },

      // Operating Budget Items
      "budgetItems": {
        "assurance_multirisques": "Multi-risk building insurance",
        "assurance_responsabilite": "Liability insurance",
        "assurance_renouvellement": "Insurance (annual contract renewal)",
        "entretien_toiture": "Roof and gutter maintenance",
        "entretien_cloches": "Bell and campanile maintenance",
        "entretien_facade": "Facade and joinery maintenance",
        "entretien_chauffage": "Heating and boiler maintenance",
        "entretien_ventilation": "Ventilation/air conditioning maintenance",
        "entretien_ascenseur": "Elevator maintenance (if present)",
        "entretien_electricite": "Electrical maintenance (control, verification)",
        "entretien_plomberie": "Plumbing and sanitary maintenance",
        "entretien_alarme": "Alarm and security equipment",
        "securite": "Security networks",
        "entretien_batiment": "Building maintenance (painting, doors, windows…)",
        "jardin": "Garden",
        "panneaux_solaires": "Solar panels",
        "reseau_informatique": "IT network",
        "chauffage_annuel": "Gas",
        "electricite": "Electricity",
        "eau": "Water",
        "electricite_eau_sanitaire": "Fuel oil",
        "nettoyage_regulier": "Internal contract",
        "nettoyage_specialise": "External contract",
        "salaire_gardien": "Salary of staff assigned 100% to the building",
        "salaire_maintenance": "Pro-rata staff salary shared between buildings",
        "honoraires_syndic": "Management/administrative fees",
        "revenu_location": "Rental income",
        "vente_energie_renouvelable": "Renewable energy sales",
        "dons_legs": "Donations and bequests",
        "divers": "Miscellaneous"
      },

      // Operating Budget Frequencies
      "budgetFrequencies": {
        "annuel": "Annual",
        "selon_besoin": "As needed",
        "mensuel": "Monthly",
        "hebdomadaire_mensuel": "Weekly/monthly",
        "trimestriel": "Quarterly"
      },

      // Operating Budget Natures
      "budgetNatures": {
        "recurrente": "Recurring",
        "maintenance": "Maintenance",
        "energie": "Energy",
        "nettoyage": "Cleaning",
        "personnel": "Personnel",
        "gestion": "Management"
      },

      // Profile
      "myProfile": "My Profile",
      "personalInfo": "Personal Information",
      "changePassword": "Change Password",
      "changePasswordHint": "Leave these fields empty if you don't want to change your password.",
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "confirmPassword": "Confirm Password",
      "passwordMinLength": "Minimum 12 characters",
      "passwordMismatch": "Passwords do not match",
      "passwordRequirements": "Password requirements:",
      "passwordReqMinLength": "At least 12 characters",
      "passwordReqLowercase": "At least one lowercase letter",
      "passwordReqUppercase": "At least one uppercase letter",
      "passwordReqDigit": "At least one digit",
      "passwordReqSpecial": "At least one special character (@$!%*?&#)",
      "currentPasswordRequired": "Current password is required to change password",
      "profileUpdateSuccess": "Profile updated successfully",
      "profileUpdateError": "Error updating profile",
      "profileLoadError": "Error loading profile",
      "saving": "Saving..."
    }
  },
  pt: {
    translation: {
      "sites": "Locais",
      "logout": "Sair",
      "login": "Entrar",
      "email": "Email",
      "password": "Senha",
      "signIn": "Conectar",
      "forgotPassword": "Esqueceu a senha?",
      "forgotPasswordDescription": "Digite seu endereço de email. Uma nova senha será gerada e enviada para você por email.",
      "sendNewPassword": "Enviar nova senha",
      "forgotPasswordSuccess": "Se uma conta existir com este email, uma nova senha foi enviada.",
      "forgotPasswordError": "Erro ao redefinir a senha. Por favor, tente novamente.",
      "close": "Fechar",

      // Errors
      "errorTitle": "Erro",
      "saveError": "Erro ao salvar",
      "validationError": "Erro de validação",
      "fields": {
        "nom_site": "Nome do local",
        "adresse": "Endereço",
        "ville": "Cidade",
        "pays": "País",
        "province": "Província",
        "congregation": "Congregação",
        "type_batiment": "Tipo de edifício",
        "annee_acquisition": "Ano de aquisição",
        "surface_jardins": "Área do jardim",
        "nombre_batiments": "Número de edifícios",
        "nombre_personnes_residentes": "Número de residentes",
        "nombre_employes": "Número de funcionários",
        "nombre_personnes_accueillis": "Número de hóspedes"
      },

      "sitesList": "Lista de Locais",
      "addSite": "Adicionar Local",
      "siteName": "Nome do Local",
      "city": "Cidade",
      "country": "País",
      "operatingBudget": "Orçamento Operacional",
      "expensesAmount": "Montante Despesas",
      "revenuesAmount": "Montante Receitas",
      "sortBy": "Ordenar por",
      "sortDefault": "Ordem padrão",
      "toggleSortDirection": "Inverter a ordem",
      "investmentBudget": "Orçamento de Investimento",
      "actions": "Ações",
      "edit": "Editar",
      "delete": "Excluir",
      "generatePdf": "Gerar PDF",
      "exportPdf": "Exportar lista em PDF",
      "exportData": "Exportar dados",
      "exportSiteListPdf": "Exportar lista de sites em PDF",
      "exportAssessmentsPdf": "Exportar últimos diagnósticos em PDF",
      "noAssessmentsToExport": "Nenhum diagnóstico concluído para os sites apresentados.",
      "exportAssessmentsError": "Erro ao exportar os diagnósticos.",
      "exportExcel": "Exportar lista em Excel",
      "searchFilter": "Filtro",
      "totalSites": "Locais totais",
      "filteredSites": "Locais filtrados",
      "outOf": "de",
      "totalSitesCount": "locais no total",
      "filteredSelection": "Seleção filtrada",
      "siteIdentity": "Identidade do Local",
      "riskAnalysis": "Lista de Investimentos",
      "operatingBudgetTab": "Orçamento Operacional",
      "investmentBudgetTab": "Orçamento de Investimento",
      "save": "Salvar",
      "cancel": "Cancelar",
      "previous": "Anterior",
      "next": "Próximo",
      "address": "Endereço",
      "buildingType": "Tipo de Edifício",
      "destination": "Uso do Local",
      "siteUsage": "Uso do Local",
      "legalStatus": "Status Legal",
      "owner": "Proprietário",
      "tenant": "Inquilino",
      "rented": "Alugado",
      "occupationStatus": "Status de Ocupação",
      "easement": "Servidão",
      "yes": "Sim",
      "no": "Não",
      "unknown": "Desconhecido",
      "acquisitionYear": "Ano de aquisição ou construção",
      "rentalYear": "Ano de Aluguel",
      "rentedSince": "Alugado desde",
      "rentedUntil": "Alugado até",
      "building": "Edifício",
      "buildingUsage": "Uso do edifício",
      "buildingSurface": "Superfície do edifício (m²)",
      "gardenSurface": "Superfície dos jardins (m²)",
      "floors": "Número de níveis",
      "buildings": "Número de Edifícios",
      "people": "Número de Pessoas",
      "residentsCount": "Número de Irmãs Residentes",
      "employeesCount": "Número de Funcionários",
      "guestsCount": "Capacidade de acolhimento",
      "currency": "Moeda do País",
      "province": "Província/Região",
      "congregation": "Congregação",
      "image": "Foto do Local",
      "sitePhotoDescription": "Foto principal de identificação do local",
      "uploadImage": "Carregar foto",
      "changeImage": "Alterar foto",
      "siteDocuments": "Documentos do local",
      "siteDocumentsDescription": "Adicione aqui os documentos relativos ao local: escrituras de propriedade, contratos de locação, plantas, etc.",
      "addDocument": "Adicionar um documento",
      "addDocumentHint": "PDF, JPEG, PNG (máx. 10 MB)",
      "noDocuments": "Nenhum documento adicionado",
      "saveSiteFirst": "Por favor, salve o local primeiro para adicionar documentos",
      "documentUploaded": "Documento adicionado com sucesso",
      "documentDeleted": "Documento excluído com sucesso",
      "documentUploadError": "Erro ao adicionar o documento",
      "documentDeleteError": "Erro ao excluir o documento",
      "confirmDeleteDocument": "Tem certeza de que deseja excluir este documento?",

      // Provinces
      "provinces": {
        "bresil": "Brasil",
        "region_asie": "Região Ásia",
        "madagascar": "Madagascar",
        "europe_togo": "Europa-Togo",
        "amerique_nord": "América do Norte",
        "nouvelle_zelande": "Nova Zelândia",
        "generalat": "Generalato"
      },

      // Building Types
      "buildingTypes": {
        "maison_accueil": "Casa de acolhimento/Retiros Espirituais",
        "maison_retraite": "Casa das irmãs idosas",
        "maison_cimetiere": "Jazigo Funerário",
        "chapelle": "Casa sem acolhimento (formação/comunidade/Provincialato…)",
        "eglise": "Igreja - Capela",
        "dependance": "Dependência",
        "autre": "Outro"
      },

      // Occupation Statuses
      "occupationStatuses": {
        "occupant": "Ocupante",
        "occupantPartiel": "Ocupante Parcial",
        "miseEnLocation": "Para Locação"
      },

      // Currencies
      "currencies": {
        "EUR": "Euro (€)",
        "BRL": "Real brasileiro (R$)",
        "MGA": "Ariary malgaxe (Ar)",
        "PHP": "Peso filipino (₱)",
        "NZD": "Dólar neozelandês (NZ$)",
        "USD": "Dólar americano ($)",
        "MOP": "Pataca de Macau (MOP$)",
        "SGD": "Dólar de Singapura (S$)",
        "XOF": "Franco CFA (TOGO) (CFA)",
        "GBP": "Libra esterlina (£)",
        "AUD": "Dólar australiano (A$)"
      },

      // Administration
      "administration": "Administração",
      "users": "Utilizadores",
      "permissions": "Permissões",
      "userManagement": "Gestão de Utilizadores",
      "permissionManagement": "Gestão de Permissões",
      "addUser": "Adicionar Utilizador",
      "editUser": "Editar Utilizador",
      "firstName": "Nome",
      "lastName": "Sobrenome",
      "language": "Idioma",
      "admin": "Admin",
      "isAdmin": "É Administrador",
      "addPermission": "Adicionar Permissão",
      "editPermission": "Editar Permissão",
      "user": "Utilizador",
      "site": "Local",
      "canView": "Pode Ver",
      "canEdit": "Pode Editar",
      "canDelete": "Pode Eliminar",
      "required": "Obrigatório",
      "leaveEmptyToKeepCurrent": "Deixe vazio para manter a senha atual",
      "confirmDeleteUser": "Tem certeza que deseja eliminar este utilizador?",
      "confirmDeletePermission": "Tem certeza que deseja eliminar esta permissão?",
      "userCreatedSuccess": "Utilizador criado com sucesso",
      "userUpdatedSuccess": "Utilizador atualizado com sucesso",
      "userDeletedSuccess": "Utilizador eliminado com sucesso",
      "permissionSavedSuccess": "Permissão guardada com sucesso",
      "permissionDeletedSuccess": "Permissão eliminada com sucesso",
      "errorFetchingUsers": "Erro ao carregar utilizadores",
      "errorFetchingSites": "Erro ao carregar locais",
      "errorFetchingPermissions": "Erro ao carregar permissões",
      "errorSavingUser": "Erro ao guardar utilizador",
      "errorDeletingUser": "Erro ao eliminar utilizador",
      "errorSavingPermission": "Erro ao guardar permissão",
      "errorDeletingPermission": "Erro ao eliminar permissão",
      "passwordRequired": "A senha é obrigatória",
      "accessDeniedAdmin": "Acesso negado: direitos de administrador necessários",
      "errorCheckingAdmin": "Erro ao verificar direitos de administrador",
      "role": "Função",
      "userProvince": "Província do utilizador",
      "roles": {
        "super_admin": "Super Administrador",
        "admin_province": "Administrador Provincial",
        "user": "Utilizador"
      },
      "rolesDescription": {
        "title": "Direitos por função",
        "permission": "Permissão",
        "super_admin_desc": "Acesso total a todos os locais e funcionalidades. Pode gerir utilizadores, permissões e validar investimentos de todas as províncias.",
        "admin_province_desc": "Acesso apenas aos locais da sua província. Pode criar utilizadores e gerir permissões na sua província. Pode validar investimentos da sua província.",
        "user_desc": "Acesso apenas aos locais que criou ou para os quais foram atribuídas permissões explícitas.",
        "manage_users": "Gerir utilizadores",
        "manage_permissions": "Gerir permissões",
        "validate_investments": "Validar investimentos",
        "access_all_sites": "Acesso a todos os locais",
        "access_province_sites": "Acesso aos locais da província",
        "create_sites": "Criar locais",
        "all_provinces": "Todas as províncias",
        "own_province_only": "Apenas a sua província",
        "assigned_sites_only": "Apenas locais atribuídos"
      },
      "validationStatus": {
        "en_attente": "Pendente",
        "valide": "Validado",
        "rejete": "Rejeitado"
      },
      "validate": "Validar",
      "reject": "Rejeitar",
      "validationComment": "Comentário de validação",
      "pendingValidations": "Validações pendentes",
      "validatedBy": "Validado por",
      "validatedAt": "Validado em",
      "validationTab": "Validações",
      "status": "Estado",
      "investmentValidated": "Investimento validado com sucesso",
      "investmentRejected": "Investimento rejeitado",
      "noValidationPermission": "Não tem direitos de validação",

      "addRisk": "Adicionar Investimento",
      "investmentLabel": "Investimento",
      "removeValidation": "Remover validação",
      "theme": "Tema",
      "item": "Item",
      "description": "Descrição",
      "riskExists": "Existe um risco?",
      "why": "Por quê?",
      "attachedFile": "Arquivo anexado",
      "uploadFile": "Anexar um arquivo",
      "viewFile": "Visualizar",
      "downloadFile": "Baixar",
      "deleteFile": "Excluir",
      "saveInvestmentFirst": "Salve o investimento primeiro para anexar um arquivo",
      "fileUploadError": "Erro ao enviar arquivo",
      "fileViewError": "Erro ao visualizar arquivo",
      "fileDownloadError": "Erro ao baixar arquivo",
      "fileDeleteError": "Erro ao excluir arquivo",
      "confirmDeleteFile": "Tem certeza de que deseja excluir este arquivo?",
      "urgency": "URGÊNCIA (Existe um risco imediato?)",
      "security": "SEGURANÇA (A segurança das pessoas está ameaçada?)",
      "regulatory": "LEGAL / REGULAMENTAR (Existe um risco legal ou regulamentar?)",
      "financial": "FINANCEIRO (Haverá agravamento do custo em caso de não-ação rápida?)",
      "geoWeighting": "Ponderação Geográfica (%)",
      "severityLevel": "Nível de Gravidade",
      "critical": "Crítico",
      "important": "Importante",
      "moderate": "Moderado",
      "low": "Baixo",
      "observations": "Observações",
      "other": "Outro",
      "category": "Categoria",
      "budgetItem": "Item",
      "frequency": "Frequência",
      "nature": "Natureza",
      "amount": "Valor",
      "annualAmount": "Valor anual",
      "score": "Pontuação",
      "investmentAmount": "Valor do Investimento",
      "adjustment": "Ajuste (%)",
      "adjustedAmount": "Valor Ajustado",
      "quotationOrigin": "Origem da Cotação",
      "yearN": "Ano N",
      "yearN1": "Ano N+1",
      "yearN2": "Ano N+2",
      "yearN3": "Ano N+3",
      "yearN4": "Ano N+4",
      "yearN5": "Ano N+5",
      "scope": "Perímetro",
      "building": "Edifício",
      "entireSite": "Todo o local",
      "referenceYear": "Ano de referência",
      "forecastAmount": "Valor previsto",
      "realizedAmount": "Valor realizado",
      "forecast": "Previsto",
      "realized": "Realizado",
      "annualDetail": "Detalhe anual",
      "annualBreakdown": "Distribuição anual",
      "totalForecast": "Total previsto",
      "totalRealized": "Total realizado",
      "year": "Ano",
      "expand": "Detalhar por edifício",
      "collapse": "Recolher",
      "siteTotal": "Total do local",
      "perBuilding": "Por edifício",
      "expandHint": "Clique para inserir um orçamento por edifício",
      "collapseHint": "Recolher: voltar ao orçamento global",
      "expandConfirmTitle": "Mudar para orçamento por edifício?",
      "expandConfirmMessage": "O montante global desta linha será reposto e substituído por uma entrada por edifício. Confirmar?",
      "collapseConfirmTitle": "Voltar ao orçamento global?",
      "collapseConfirmMessage": "Os montantes inseridos por edifício serão somados numa única linha do site e os comentários agrupados. Confirmar?",
      "confirm": "Confirmar",
      "cancel": "Cancelar",
      "congregationForm": "Formulário da Congregação",
      "budgetAllocationControl": "Controle de Afetação de Orçamento",
      "riskScores": "Pontuações de Risco",
      "riskCount": "Nº de Investimentos",
      "totalExpenses": "Total Despesas",
      "totalRevenues": "Total Receitas",
      "operatingBudgetTotal": "Orçamento Operacional",
      "exportOperatingBudget": "Exportar orçamento operacional (Excel)",
      "exportInvestmentBudget": "Exportar orçamento de investimento (Excel)",
      "exportSiteList": "Exportar lista de sites",
      "exportConsolidatedOperating": "Orçamento operacional consolidado por província",
      "exportConsolidatedInvestment": "Orçamento de investimento consolidado por província",
      "exportDetailedOperating": "Orçamento operacional detalhado por site",
      "subtotal": "Subtotal",
      "comment": "Comentário",
      "addComment": "Adicionar um comentário",
      "editComment": "Editar comentário",
      "saveComment": "Salvar",
      "cancelComment": "Cancelar",
      "noComment": "Sem comentário",
      "search": "Pesquisar",
      "searchSites": "Pesquisar locais...",
      "plans": "Planos",
      "siteMap": "Mapa dos Locais",
      "noCoordinates": "Sem coordenadas GPS",
      "high": "Alto",
      "veryHigh": "Muito Alto",
      "userGuide": "Guia do Usuário",

      // Thematiques (Risk Analysis)
      "thematiques": {
        "statut_juridique": "Estatuto jurídico do bem",
        "assurance": "Seguro do patrimônio",
        "conformite": "Conformidade regulamentar",
        "gros_oeuvre": "Estado da estrutura",
        "reseaux": "Redes técnicas",
        "patrimoine_protege": "Patrimônio protegido / classificado",
        "environnement": "Restrições ambientais / climáticas",
        "incidents": "Incidentes recentes / degradações",
        "audits": "Auditorias e inspeções",
        "pmr": "Acessibilidade para pessoas com mobilidade reduzida",
        "incendie": "Segurança contra incêndios",
        "autre": "Outro"
      },

      // Risk Items
      "riskItems": {
        "titre_propriete": "Título de propriedade / escritura notarial",
        "contentieux_cours": "Litígio em andamento",
        "precedent_litige": "Precedente de litígio",
        "revendication_recente": "Reivindicação recente",
        "assurance_multirisques": "Seguro multirriscos",
        "garantie_decennale": "Garantia decenal",
        "attestation_recente": "Certificado recente",
        "contrat_renouveler": "Contrato a renovar",
        "securite_incendie": "Segurança contra incêndios",
        "accessibilite_pmr": "Acessibilidade PMR",
        "normes_electriques": "Normas elétricas",
        "normes_hvac": "Normas HVAC",
        "murs_facades": "Paredes exteriores / fachadas",
        "charpente_toiture": "Estrutura / telhado",
        "fondation_sol": "Fundação / solo",
        "escaliers_principal": "Escadas / escada principal",
        "electricite_reseau": "Eletricidade",
        "plomberie": "Canalização",
        "chauffage_ventilation": "Aquecimento / ventilação",
        "systemes_securite_incendie": "Sistemas de segurança contra incêndios",
        "chapelle_classee": "Capela classificada ou monumento histórico",
        "facades_protegees": "Fachadas protegidas",
        "interieur_classe": "Interior classificado",
        "zones_reglementees": "Zonas regulamentadas",
        "humidite_moisissures": "Humidade / bolor",
        "pollution_urbaine": "Poluição urbana",
        "risques_gel_chaleur": "Riscos de gelo / calor",
        "actions_energetiques": "Ações energéticas",
        "infiltration": "Infiltração",
        "fissures_surface": "Fissuras superficiais",
        "peintures_ecaillees": "Pintura descascada",
        "degradation_structurelle": "Degradação estrutural",
        "audit_structure": "Auditoria estrutural",
        "audit_electrique": "Auditoria elétrica",
        "audit_environnemental": "Auditoria ambiental",
        "controles_reglementaires": "Inspeções regulamentares",
        "escaliers_etroits": "Escadas estreitas",
        "rampes_inexistantes": "Rampas inexistentes / inadequadas",
        "ascenseur_prevoir": "Elevador a prever",
        "signaletique_adaptee": "Sinalização adaptada",
        "detecteurs_incendie": "Detetores de incêndio",
        "extincteurs": "Extintores",
        "systemes_alarme": "Sistemas de alarme",
        "compartimentage": "Compartimentação",
        "autre": "Outro"
      },

      // Operating Budget Categories
      "budgetCategories": {
        "assurances": "Seguros",
        "entretien_maintenance": "Manutenção & Conservação",
        "energie": "Energia",
        "nettoyage_hygiene": "Limpeza & Higiene",
        "personnel_gestion": "Pessoal & Gestão",
        "revenus": "Receitas"
      },

      // Operating Budget Items
      "budgetItems": {
        "assurance_multirisques": "Seguro multirriscos edifício",
        "assurance_responsabilite": "Seguro de responsabilidade civil",
        "assurance_renouvellement": "Seguro (renovação contrato anual)",
        "entretien_toiture": "Manutenção de telhado e calhas",
        "entretien_cloches": "Manutenção de sinos e campanário",
        "entretien_facade": "Manutenção de fachada e esquadrias",
        "entretien_chauffage": "Manutenção de aquecimento e caldeira",
        "entretien_ventilation": "Manutenção de ventilação/ar condicionado",
        "entretien_ascenseur": "Manutenção de elevador (se presente)",
        "entretien_electricite": "Manutenção elétrica (controle, verificação)",
        "entretien_plomberie": "Manutenção de encanamento e sanitários",
        "entretien_alarme": "Equipamentos de alarme e segurança",
        "securite": "Redes de segurança",
        "entretien_batiment": "Manutenção do edifício (pintura, portas, janelas…)",
        "jardin": "Jardim",
        "panneaux_solaires": "Painéis solares",
        "reseau_informatique": "Rede informática",
        "chauffage_annuel": "Gás",
        "electricite": "Eletricidade",
        "eau": "Água",
        "electricite_eau_sanitaire": "Óleo combustível",
        "nettoyage_regulier": "Contrato Interno",
        "nettoyage_specialise": "Contrato Externo",
        "salaire_gardien": "Salário do pessoal afetado a 100% ao imóvel",
        "salaire_maintenance": "Quota-parte do salário do pessoal repartida entre imóveis",
        "honoraires_syndic": "Honorários síndico/gestão administrativa",
        "revenu_location": "Receita de aluguel",
        "vente_energie_renouvelable": "Venda de energia renovável",
        "dons_legs": "Doações e legados",
        "divers": "Diversos"
      },

      // Operating Budget Frequencies
      "budgetFrequencies": {
        "annuel": "Anual",
        "selon_besoin": "Conforme necessidade",
        "mensuel": "Mensal",
        "hebdomadaire_mensuel": "Semanal/mensal",
        "trimestriel": "Trimestral"
      },

      // Operating Budget Natures
      "budgetNatures": {
        "recurrente": "Recorrente",
        "maintenance": "Manutenção",
        "energie": "Energia",
        "nettoyage": "Limpeza",
        "personnel": "Pessoal",
        "gestion": "Gestão"
      },

      // Profile
      "myProfile": "Meu Perfil",
      "personalInfo": "Informações pessoais",
      "changePassword": "Alterar senha",
      "changePasswordHint": "Deixe estes campos vazios se não deseja alterar a senha.",
      "currentPassword": "Senha atual",
      "newPassword": "Nova senha",
      "confirmPassword": "Confirmar senha",
      "passwordMinLength": "Mínimo 12 caracteres",
      "passwordMismatch": "As senhas não correspondem",
      "passwordRequirements": "Requisitos da senha:",
      "passwordReqMinLength": "Pelo menos 12 caracteres",
      "passwordReqLowercase": "Pelo menos uma letra minúscula",
      "passwordReqUppercase": "Pelo menos uma letra maiúscula",
      "passwordReqDigit": "Pelo menos um dígito",
      "passwordReqSpecial": "Pelo menos um caractere especial (@$!%*?&#)",
      "currentPasswordRequired": "A senha atual é necessária para alterar a senha",
      "profileUpdateSuccess": "Perfil atualizado com sucesso",
      "profileUpdateError": "Erro ao atualizar o perfil",
      "profileLoadError": "Erro ao carregar o perfil",
      "saving": "Salvando..."
    }
  },
  mg: {
    translation: {
      "sites": "Toerana",
      "logout": "Hivoaka",
      "login": "Hiditra",
      "email": "Email",
      "password": "Teny miafina",
      "signIn": "Hiditra",
      "forgotPassword": "Hadinoinao ny teny miafina?",
      "forgotPasswordDescription": "Ampidiro ny adiresy email-nao. Teny miafina vaovao no hoforonina ka halefa aminao amin'ny email.",
      "sendNewPassword": "Handefa teny miafina vaovao",
      "forgotPasswordSuccess": "Raha misy kaonty mifanaraka amin'io email io, teny miafina vaovao no nalefa.",
      "forgotPasswordError": "Nisy olana tamin'ny famerenana ny teny miafina. Avereno azafady.",
      "close": "Hidio",

      // Errors
      "errorTitle": "Hadisoana",
      "saveError": "Hadisoana tamin'ny fitahirizana",
      "validationError": "Hadisoana fanamarinana",
      "fields": {
        "nom_site": "Anaran'ny toerana",
        "adresse": "Adiresy",
        "ville": "Tanàna",
        "pays": "Firenena",
        "province": "Faritany",
        "congregation": "Fiangonana",
        "type_batiment": "Karazan'ny trano",
        "annee_acquisition": "Taona nahazoana",
        "surface_jardins": "Velarantany zaridaina",
        "nombre_batiments": "Isan'ny trano",
        "nombre_personnes_residentes": "Isan'ny mponina",
        "nombre_employes": "Isan'ny mpiasa",
        "nombre_personnes_accueillis": "Isan'ny vahiny"
      },

      "sitesList": "Lisitr'ny toerana",
      "addSite": "Manampy toerana",
      "siteName": "Anaran'ny toerana",
      "city": "Tanàna",
      "country": "Firenena",
      "operatingBudget": "Tetibola fiasana",
      "expensesAmount": "Totalin'ny Fandaniana",
      "revenuesAmount": "Totalin'ny Vola Miditra",
      "sortBy": "Alahatra araka",
      "sortDefault": "Filaharana mahazatra",
      "toggleSortDirection": "Avadika ny filaharana",
      "investmentBudget": "Tetibola fampiasam-bola",
      "actions": "Asa",
      "edit": "Hanova",
      "delete": "Hamafa",
      "generatePdf": "Hamorona PDF",
      "exportPdf": "Hamoaka lisitra ho PDF",
      "exportData": "Hamoaka angona",
      "exportSiteListPdf": "Hamoaka lisitry ny toerana ho PDF",
      "exportAssessmentsPdf": "Hamoaka ny fanadihadiana farany ho PDF",
      "noAssessmentsToExport": "Tsy misy fanadihadiana vita ho an'ireo toerana aseho.",
      "exportAssessmentsError": "Nisy olana tamin'ny famoahana ny fanadihadiana.",
      "exportExcel": "Hamoaka lisitra ho Excel",
      "searchFilter": "Sivana",
      "totalSites": "Toerana rehetra",
      "filteredSites": "Toerana voasivana",
      "outOf": "amin'ny",
      "totalSitesCount": "toerana rehetra",
      "filteredSelection": "Safidy voasivana",
      "siteIdentity": "Mombamomba ny toerana",
      "riskAnalysis": "Lisitry ny fampiasam-bola",
      "operatingBudgetTab": "Tetibola fiasana",
      "investmentBudgetTab": "Tetibola fampiasam-bola",
      "save": "Tehirizo",
      "cancel": "Aoka ihany",
      "previous": "Teo aloha",
      "next": "Manaraka",
      "address": "Adiresy",
      "buildingType": "Karazana trano",
      "destination": "Fampiasana ny toerana",
      "siteUsage": "Fampiasana ny toerana",
      "legalStatus": "Toe-pitsipika",
      "owner": "Tompon-trano",
      "tenant": "Mpanofa",
      "rented": "Nohofaina",
      "occupationStatus": "Toe-ponenan'ny olona",
      "easement": "Servitude",
      "yes": "Eny",
      "no": "Tsia",
      "unknown": "Tsy fantatra",
      "acquisitionYear": "Taona nahazoana na nanorenana",
      "rentalYear": "Taona nanofa",
      "rentedSince": "Nohofaina nanomboka ny",
      "rentedUntil": "Nohofaina hatramin'ny",
      "building": "Trano",
      "buildingUsage": "Fampiasana ny trano",
      "buildingSurface": "Velaran'ny trano (m²)",
      "gardenSurface": "Velaran'ny zaridaina (m²)",
      "floors": "Isan'ny ambaratonga",
      "buildings": "Isan'ny trano",
      "people": "Isan'ny olona",
      "residentsCount": "Isan'ny anabavy mponina",
      "employeesCount": "Isan'ny mpiasa",
      "guestsCount": "Fahafahan'ny fandraisana",
      "currency": "Vola",
      "province": "Faritany/Faritra",
      "congregation": "Fikambanana",
      "image": "Sarin'ny toerana",
      "sitePhotoDescription": "Sary lehibe famantarana ny toerana",
      "uploadImage": "Hampiditra sary",
      "changeImage": "Hanova ny sary",
      "siteDocuments": "Antontan-taratasy momba ny toerana",
      "siteDocumentsDescription": "Ampio eto ny antontan-taratasy momba ny toerana: taratasy fananana, fifanekena hofana, drafitra, sns.",
      "addDocument": "Hanampy antontan-taratasy",
      "addDocumentHint": "PDF, JPEG, PNG (max 10 MB)",
      "noDocuments": "Tsy misy antontan-taratasy",
      "saveSiteFirst": "Tehirizo aloha ny toerana vao afaka manampy antontan-taratasy",
      "documentUploaded": "Tafiditra soa aman-tsara ny antontan-taratasy",
      "documentDeleted": "Voafafa soa aman-tsara ny antontan-taratasy",
      "documentUploadError": "Nisy olana tamin'ny fampidirana antontan-taratasy",
      "documentDeleteError": "Nisy olana tamin'ny famafana antontan-taratasy",
      "confirmDeleteDocument": "Tena te hamafa ity antontan-taratasy ity ve ianao?",

      // Provinces
      "provinces": {
        "bresil": "Brezila",
        "region_asie": "Faritra Azia",
        "madagascar": "Madagasikara",
        "europe_togo": "Eoropa-Togo",
        "amerique_nord": "Amerika Avaratra",
        "nouvelle_zelande": "Nouvelle Zélande",
        "generalat": "Generalat"
      },

      // Building Types
      "buildingTypes": {
        "maison_accueil": "Trano fandraisana/Fitsaharana ara-panahy",
        "maison_retraite": "Tranon'ny anabavy zokiolona",
        "maison_cimetiere": "Fasana",
        "chapelle": "Trano tsy misy fandraisana (fiofanana/fikambanana/Faritany…)",
        "eglise": "Fiangonana - Trano fiangonana kely",
        "dependance": "Trano fanampiny",
        "autre": "Hafa"
      },

      // Occupation Statuses
      "occupationStatuses": {
        "occupant": "Mponina",
        "occupantPartiel": "Mponina ampahany",
        "miseEnLocation": "Hofaina"
      },

      // Currencies
      "currencies": {
        "EUR": "Euro (€)",
        "BRL": "Real breziliana (R$)",
        "MGA": "Ariary malagasy (Ar)",
        "PHP": "Peso filipina (₱)",
        "NZD": "Dolara Nouvelle-Zélande (NZ$)",
        "USD": "Dolara amerikana ($)",
        "MOP": "Pataca Macao (MOP$)",
        "SGD": "Dolara Singapour (S$)",
        "XOF": "Franc CFA (TOGO) (CFA)",
        "GBP": "Livre sterling (£)",
        "AUD": "Dolara aostraliana (A$)"
      },

      // Administration
      "administration": "Fitantanana",
      "users": "Mpampiasa",
      "permissions": "Fahazoan-dalana",
      "userManagement": "Fitantanana ny mpampiasa",
      "permissionManagement": "Fitantanana ny fahazoan-dalana",
      "addUser": "Manampy mpampiasa",
      "editUser": "Hanova mpampiasa",
      "firstName": "Anarana",
      "lastName": "Fanampin'anarana",
      "language": "Fiteny",
      "admin": "Admin",
      "isAdmin": "Mpitantana",
      "addPermission": "Manampy fahazoan-dalana",
      "editPermission": "Hanova fahazoan-dalana",
      "user": "Mpampiasa",
      "site": "Toerana",
      "canView": "Afaka mijery",
      "canEdit": "Afaka manova",
      "canDelete": "Afaka mamafa",
      "required": "Takiana",
      "leaveEmptyToKeepCurrent": "Avelao ho banga mba hitazonana ny teny miafina ankehitriny",
      "confirmDeleteUser": "Azonao antoka ve ny hamafa ity mpampiasa ity?",
      "confirmDeletePermission": "Azonao antoka ve ny hamafa ity fahazoan-dalana ity?",
      "userCreatedSuccess": "Voaforona soa aman-tsara ny mpampiasa",
      "userUpdatedSuccess": "Voahavaozina soa aman-tsara ny mpampiasa",
      "userDeletedSuccess": "Voafafa soa aman-tsara ny mpampiasa",
      "permissionSavedSuccess": "Voatahiry soa aman-tsara ny fahazoan-dalana",
      "permissionDeletedSuccess": "Voafafa soa aman-tsara ny fahazoan-dalana",
      "errorFetchingUsers": "Nisy olana tamin'ny fakana ny mpampiasa",
      "errorFetchingSites": "Nisy olana tamin'ny fakana ny toerana",
      "errorFetchingPermissions": "Nisy olana tamin'ny fakana ny fahazoan-dalana",
      "errorSavingUser": "Nisy olana tamin'ny fitahirizana ny mpampiasa",
      "errorDeletingUser": "Nisy olana tamin'ny famafana ny mpampiasa",
      "errorSavingPermission": "Nisy olana tamin'ny fitahirizana ny fahazoan-dalana",
      "errorDeletingPermission": "Nisy olana tamin'ny famafana ny fahazoan-dalana",
      "passwordRequired": "Takiana ny teny miafina",
      "accessDeniedAdmin": "Tsy ekena: takiana ny zo mpitantana",
      "errorCheckingAdmin": "Nisy olana tamin'ny fanamarinana ny zo mpitantana",
      "role": "Andraikitra",
      "userProvince": "Faritanin'ny mpampiasa",
      "roles": {
        "super_admin": "Mpitantana Ambony",
        "admin_province": "Mpitantana Faritany",
        "user": "Mpampiasa"
      },
      "rolesDescription": {
        "title": "Zo araka ny andraikitra",
        "permission": "Fahazoan-dàlana",
        "super_admin_desc": "Fidirana feno amin'ny toerana rehetra sy ny fampiasa rehetra. Afaka mitantana mpampiasa, fahazoan-dàlana ary manamarina fampiasam-bola ho an'ny faritany rehetra.",
        "admin_province_desc": "Fidirana amin'ny toerana ao amin'ny faritaniny ihany. Afaka mamorona mpampiasa sy mitantana fahazoan-dàlana ao amin'ny faritaniny. Afaka manamarina fampiasam-bola ao amin'ny faritaniny.",
        "user_desc": "Fidirana amin'ny toerana noforoniny ihany na izay nomena fahazoan-dàlana manokana.",
        "manage_users": "Mitantana mpampiasa",
        "manage_permissions": "Mitantana fahazoan-dàlana",
        "validate_investments": "Manamarina fampiasam-bola",
        "access_all_sites": "Fidirana amin'ny toerana rehetra",
        "access_province_sites": "Fidirana amin'ny toerana ao amin'ny faritany",
        "create_sites": "Mamorona toerana",
        "all_provinces": "Faritany rehetra",
        "own_province_only": "Faritaniny ihany",
        "assigned_sites_only": "Toerana nomena ihany"
      },
      "validationStatus": {
        "en_attente": "Miandry",
        "valide": "Voamarina",
        "rejete": "Nolavina"
      },
      "validate": "Hamarino",
      "reject": "Lavino",
      "validationComment": "Fanehoan-kevitra fanamarinana",
      "pendingValidations": "Fanamarinana miandry",
      "validatedBy": "Nohamarinan'i",
      "validatedAt": "Nohamarinina tamin'ny",
      "validationTab": "Fanamarinana",
      "status": "Sata",
      "investmentValidated": "Fampiasam-bola voamarina soa aman-tsara",
      "investmentRejected": "Fampiasam-bola nolavina",
      "noValidationPermission": "Tsy manana zo fanamarinana ianao",

      "addRisk": "Manampy fampiasam-bola",
      "investmentLabel": "Fampiasam-bola",
      "removeValidation": "Manala fanamarinana",
      "theme": "Lohahevitra",
      "item": "Zavatra",
      "description": "Famaritana",
      "riskExists": "Misy loza ve?",
      "why": "Nahoana?",
      "attachedFile": "Rakitra miaraka",
      "uploadFile": "Hampiditra rakitra",
      "viewFile": "Mijery",
      "downloadFile": "Misintona",
      "deleteFile": "Mamafa",
      "saveInvestmentFirst": "Tehirizo aloha ny fampiasam-bola vao afaka mampiditra rakitra",
      "fileUploadError": "Nisy olana tamin'ny fampidirana rakitra",
      "fileViewError": "Nisy olana tamin'ny fijerena rakitra",
      "fileDownloadError": "Nisy olana tamin'ny fisintona rakitra",
      "fileDeleteError": "Nisy olana tamin'ny famafana rakitra",
      "confirmDeleteFile": "Tena te hamafa ity rakitra ity ve ianao?",
      "urgency": "MAIKA (Misy loza mivantana ve?)",
      "security": "FIAROVANA (Voaraharaha ve ny fiarovana ny olona?)",
      "regulatory": "LALÀNA / FITSIPIKA (Misy loza ara-dalàna sa ara-pitsipika ve?)",
      "financial": "VOLA (Hihamafy ve ny vidiny raha tsy mihetsika haingana?)",
      "geoWeighting": "Lanjany (%)",
      "severityLevel": "Haavon'ny loza",
      "critical": "Sarotra",
      "important": "Zava-dehibe",
      "moderate": "Antonony",
      "low": "Ambany",
      "observations": "Fanamarihana",
      "other": "Hafa",
      "category": "Sokajy",
      "budgetItem": "Zavatra",
      "frequency": "Matetika",
      "nature": "Toetra",
      "amount": "Vola",
      "annualAmount": "Vola isan-taona",
      "score": "Isa",
      "investmentAmount": "Vidin'ny fampiasam-bola",
      "adjustment": "Fanitsiana (%)",
      "adjustedAmount": "Vidiny voafefy",
      "quotationOrigin": "Niavian'ny vidiny",
      "yearN": "Taona N",
      "yearN1": "Taona N+1",
      "yearN2": "Taona N+2",
      "yearN3": "Taona N+3",
      "yearN4": "Taona N+4",
      "yearN5": "Taona N+5",
      "scope": "Faritra",
      "building": "Trano",
      "entireSite": "Toerana iray manontolo",
      "referenceYear": "Taona fanondroana",
      "forecastAmount": "Vola voasoritra",
      "realizedAmount": "Vola tanteraka",
      "forecast": "Voasoritra",
      "realized": "Tanteraka",
      "annualDetail": "Antsipiriany isan-taona",
      "annualBreakdown": "Fizarana isan-taona",
      "totalForecast": "Fitambarana voasoritra",
      "totalRealized": "Fitambarana tanteraka",
      "year": "Taona",
      "expand": "Hampihena isaky ny trano",
      "collapse": "Ampihena",
      "siteTotal": "Fitambarana toerana",
      "perBuilding": "Isaky ny trano",
      "expandHint": "Tsindrio raha hampiditra tetibola isaky ny trano",
      "collapseHint": "Ampihena: miverina amin'ny tetibola maneho ny toerana",
      "expandConfirmTitle": "Hiova ho tetibola isaky ny trano?",
      "expandConfirmMessage": "Haverina ho aotra ny vola amin'ity andalana ity ary hosoloina fidirana isaky ny trano. Hamafisina?",
      "collapseConfirmTitle": "Hiverina amin'ny tetibola ankapobeny?",
      "collapseConfirmMessage": "Hampiarahina ho andalana toerana tokana ny vola nampidirina isaky ny trano ary hatambatra ny fanamarihana. Hamafisina?",
      "confirm": "Hamafisina",
      "cancel": "Hanafoana",
      "congregationForm": "Taratasy fanontaniana",
      "budgetAllocationControl": "Fanaraha-maso ny tetibola",
      "riskScores": "Isan'ny loza",
      "riskCount": "Isan'ny fampiasam-bola",
      "totalExpenses": "Fitambarana Fandaniana",
      "totalRevenues": "Fitambarana Vola Miditra",
      "operatingBudgetTotal": "Tetibola Fiasana",
      "exportOperatingBudget": "Hamoaka tetibola fiasana (Excel)",
      "exportInvestmentBudget": "Hamoaka tetibola fampiasam-bola (Excel)",
      "exportSiteList": "Hamoaka lisitry ny toerana",
      "exportConsolidatedOperating": "Tetibola fiasana mitambatra isaky ny faritany",
      "exportConsolidatedInvestment": "Tetibola fampiasam-bola mitambatra isaky ny faritany",
      "exportDetailedOperating": "Tetibola fiasana antsipiriany isaky ny toerana",
      "subtotal": "Fitambarana",
      "comment": "Fanehoan-kevitra",
      "addComment": "Hanampy fanehoan-kevitra",
      "editComment": "Hanova fanehoan-kevitra",
      "saveComment": "Tehirizina",
      "cancelComment": "Hanafoana",
      "noComment": "Tsy misy fanehoan-kevitra",
      "search": "Fikarohana",
      "searchSites": "Mikaroka toerana...",
      "plans": "Drafitra",
      "siteMap": "Sarintanin'ny toerana",
      "noCoordinates": "Tsy misy toerana GPS",
      "high": "Avo",
      "veryHigh": "Tena avo",
      "userGuide": "Torolalana fampiasana",

      // Thematiques (Risk Analysis)
      "thematiques": {
        "statut_juridique": "Sata ara-dalàna ny fananana",
        "assurance": "Fiantohana ny fananana",
        "conformite": "Fanarahan-dalàna",
        "gros_oeuvre": "Toetry ny rafitra",
        "reseaux": "Tambajotra teknika",
        "patrimoine_protege": "Fananana voaro / voasokajy",
        "environnement": "Fepetra ara-tontolo iainana / toetr'andro",
        "incidents": "Loza vao haingana / fahasimbana",
        "audits": "Fandinihana sy fanaraha-maso",
        "pmr": "Fidirana ho an'ny olona manana fahasembanana",
        "incendie": "Fiarovana amin'ny afo",
        "autre": "Hafa"
      },

      // Risk Items
      "riskItems": {
        "titre_propriete": "Taratasy fananana / acte notarié",
        "contentieux_cours": "Ady eo am-pandehanana",
        "precedent_litige": "Ady taloha",
        "revendication_recente": "Fitakiana vao haingana",
        "assurance_multirisques": "Fiantohana feno",
        "garantie_decennale": "Antoka folo taona",
        "attestation_recente": "Fanamarinana vao haingana",
        "contrat_renouveler": "Fifanarahana havaozina",
        "securite_incendie": "Fiarovana amin'ny afo",
        "accessibilite_pmr": "Fidirana PMR",
        "normes_electriques": "Fenitra herinaratra",
        "normes_hvac": "Fenitra HVAC",
        "murs_facades": "Rindrina ivelany / façades",
        "charpente_toiture": "Hazo mitraka / tafo",
        "fondation_sol": "Fototra / tany",
        "escaliers_principal": "Tohatra / tohatra lehibe",
        "electricite_reseau": "Herinaratra",
        "plomberie": "Fantsona",
        "chauffage_ventilation": "Fanafanana / rivotra",
        "systemes_securite_incendie": "Rafitra fiarovana amin'ny afo",
        "chapelle_classee": "Trano fiangonana kely voasokajy na tsangambato ara-tantara",
        "facades_protegees": "Façades voaro",
        "interieur_classe": "Anatiny voasokajy",
        "zones_reglementees": "Faritra voafehy",
        "humidite_moisissures": "Hamandoana / fofom-potaka",
        "pollution_urbaine": "Fahalotoan'ny tanàn-dehibe",
        "risques_gel_chaleur": "Loza avy amin'ny hatsiaka / hafanana",
        "actions_energetiques": "Asa ara-angovo",
        "infiltration": "Fidiran-drano",
        "fissures_surface": "Triatra eny amboniny",
        "peintures_ecaillees": "Loko mitresaka",
        "degradation_structurelle": "Fahasimban'ny rafitra",
        "audit_structure": "Fandinihana rafitra",
        "audit_electrique": "Fandinihana herinaratra",
        "audit_environnemental": "Fandinihana tontolo iainana",
        "controles_reglementaires": "Fanaraha-maso ara-pitsipika",
        "escaliers_etroits": "Tohatra tery",
        "rampes_inexistantes": "Rampes tsy misy / tsy ampy",
        "ascenseur_prevoir": "Ascenseur tokony haorina",
        "signaletique_adaptee": "Famantarana mifanaraka",
        "detecteurs_incendie": "Mpitsikilo afo",
        "extincteurs": "Mpamono afo",
        "systemes_alarme": "Rafitra fanairana",
        "compartimentage": "Fizarazarana",
        "autre": "Hafa"
      },

      // Operating Budget Categories
      "budgetCategories": {
        "assurances": "Fiantohana",
        "entretien_maintenance": "Fikojakojana & Fikarakarana",
        "energie": "Angovo",
        "nettoyage_hygiene": "Fanadiovana & Fahadiovana",
        "personnel_gestion": "Mpiasa & Fitantanana",
        "revenus": "Vola miditra"
      },

      // Operating Budget Items
      "budgetItems": {
        "assurance_multirisques": "Fiantohana feno ny trano",
        "assurance_responsabilite": "Fiantohana andraikitra sivily",
        "assurance_renouvellement": "Fiantohana (fanavaozana fifanarahana isan-taona)",
        "entretien_toiture": "Fikojakojana tafo sy lakandrano",
        "entretien_cloches": "Fikojakojana lakolosy sy campanile",
        "entretien_facade": "Fikojakojana endrika sy varavarana",
        "entretien_chauffage": "Fikojakojana fanafanana sy chaudière",
        "entretien_ventilation": "Fikojakojana rivotra/climatisation",
        "entretien_ascenseur": "Fikojakojana ascenseur (raha misy)",
        "entretien_electricite": "Fikojakojana herinaratra (fanaraha-maso, fanamarinana)",
        "entretien_plomberie": "Fikojakojana fantsona sy trano fidiovana",
        "entretien_alarme": "Fitaovana fanairana sy fiarovana",
        "securite": "Tambajotra fiarovana",
        "entretien_batiment": "Fikojakojana trano (loko, varavarana, varavarankely…)",
        "jardin": "Zaridaina",
        "panneaux_solaires": "Panneaux solaires",
        "reseau_informatique": "Tambajotra informatika",
        "chauffage_annuel": "Gazy",
        "electricite": "Herinaratra",
        "eau": "Rano",
        "electricite_eau_sanitaire": "Solika",
        "nettoyage_regulier": "Fifanarahana anatiny",
        "nettoyage_specialise": "Fifanarahana ivelany",
        "salaire_gardien": "Karaman'ny mpiasa voatokana 100% ho an'ny trano",
        "salaire_maintenance": "Ampahany karaman'ny mpiasa zaraina amin'ny trano maro",
        "honoraires_syndic": "Sarambola syndic/fitantanana",
        "revenu_location": "Vola azo avy amin'ny fanofana",
        "vente_energie_renouvelable": "Fivarotana angovo azo havaozina",
        "dons_legs": "Fanomezana sy lova",
        "divers": "Samihafa"
      },

      // Operating Budget Frequencies
      "budgetFrequencies": {
        "annuel": "Isan-taona",
        "selon_besoin": "Araka izay ilaina",
        "mensuel": "Isam-bolana",
        "hebdomadaire_mensuel": "Isan-kerinandro/isam-bolana",
        "trimestriel": "Isaky ny telo volana"
      },

      // Operating Budget Natures
      "budgetNatures": {
        "recurrente": "Miverimberina",
        "maintenance": "Fikojakojana",
        "energie": "Angovo",
        "nettoyage": "Fanadiovana",
        "personnel": "Mpiasa",
        "gestion": "Fitantanana"
      },

      // Profile
      "myProfile": "Ny mombamomba ahy",
      "personalInfo": "Fampahalalana manokana",
      "changePassword": "Hanova teny miafina",
      "changePasswordHint": "Avelao banga ireo saha ireo raha tsy te-hanova teny miafina ianao.",
      "currentPassword": "Teny miafina ankehitriny",
      "newPassword": "Teny miafina vaovao",
      "confirmPassword": "Hamafiso ny teny miafina",
      "passwordMinLength": "12 litera farafahakeliny",
      "passwordMismatch": "Tsy mitovy ny teny miafina",
      "passwordRequirements": "Fepetra takiana amin'ny teny miafina:",
      "passwordReqMinLength": "12 litera farafahakeliny",
      "passwordReqLowercase": "Litera kely iray farafahakeliny",
      "passwordReqUppercase": "Litera lehibe iray farafahakeliny",
      "passwordReqDigit": "Isa iray farafahakeliny",
      "passwordReqSpecial": "Marika manokana iray farafahakeliny (@$!%*?&#)",
      "currentPasswordRequired": "Ilaina ny teny miafina ankehitriny mba hanovana ny teny miafina",
      "profileUpdateSuccess": "Voaova soa aman-tsara ny mombamomba",
      "profileUpdateError": "Nisy olana tamin'ny fanavaozana ny mombamomba",
      "profileLoadError": "Nisy olana tamin'ny famakiana ny mombamomba",
      "saving": "Mitahiry..."
    }
  }
};

const LANGUAGE_STORAGE_KEY = 'language';

// Langue au démarrage : dernier choix fait sur ce navigateur, sinon langue du profil, sinon français
function initialLanguage() {
  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (stored) return stored;
  try {
    return JSON.parse(localStorage.getItem('user'))?.language || 'fr';
  } catch {
    return 'fr';
  }
}

// Change la langue et la mémorise pour qu'elle survive à un rechargement de page
export function changeLanguage(lang) {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  return i18n.changeLanguage(lang);
}

// Applique la langue du profil à la connexion, sauf si un choix a déjà été fait sur ce navigateur
export function applyProfileLanguage(user) {
  if (!localStorage.getItem(LANGUAGE_STORAGE_KEY) && user?.language) {
    i18n.changeLanguage(user.language);
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage(),
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
